import store from '../../store/index'
import montaMensagem from '../../mixins/methods/montaMensagem';

async function chamarWhatsApp() {
    const dadosCompra = store.getters.dadosCompra
    const endereco = store.getters.endereco
    const empresa = store.getters.empresa
    const carrinhoProdutos = store.getters.cartProducts
    const idPedido = store.getters.idPedido

    const _endereco = `${endereco.logradouro} ${endereco.numero} ${endereco.bairro}, ${endereco.cidade} - ${endereco.uf}`

    const url = montaMensagem(
        empresa.whatsapp,
        dadosCompra.nome,
        dadosCompra.telefone,
        carrinhoProdutos,
        dadosCompra.formaPagamento,
        endereco.entrega,
        _endereco,
        dadosCompra.troco,
        empresa.valorentrega,
        idPedido
    )

    window.open(url)
}
export default function whatsapp() { chamarWhatsApp() }